// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import PostAutomationContactSearchRequestModel from '../../model/post-automation-contact-search-request-model';
import GetAutomationFormPayloadRequestModel from '../../model/get-automation-form-payload-request-model';
import AutomationFormPayloadModel from '../../model/automation-form-payload-model';

export default (service: Servicelayer) => ({
  /**  */
  async postAutomationContactSearch(request: PostAutomationContactSearchRequestModel, config?: RequestConfig) {
    const requestDTO = PostAutomationContactSearchRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-automation-contact-search'] ?? 'widgets/Automation/PostAutomationContactSearch';
    const response = await service.post<any>(endpointPath, {
      query: {
        customerNumber: requestDTO.customerNumber,
        lastName: requestDTO.lastName,
        tenantKey: requestDTO.tenantKey,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getAutomationFormPayload(request: GetAutomationFormPayloadRequestModel, config?: RequestConfig) {
    const requestDTO = GetAutomationFormPayloadRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-automation-form-payload'] ?? 'widgets/Automation/GetAutomationFormPayload';
    const response = await service.get<any>(endpointPath, {
      query: {
        contactId: requestDTO.contactId,
        appSystemKey: requestDTO.appSystemKey,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(AutomationFormPayloadModel.toModel(dto));
  },
});
